import { createUserManager } from 'redux-oidc';
import { WebStorageStateStore } from 'oidc-client';

const userManagerConfig = {
    client_id: 'js.panel_rezydenta',
    redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}/sign-in`,
    response_type: 'id_token token',
    scope: 'openid profile panel_rezydenta.harmonogram.web',
    state: 'd8dc2c0441ab42148b17a43b19be7ac1',
    nonce: '8b505ce9f4b240f0b578b8d7f32fb911',
    acr_values: 'ver:seller',
    authority: window.env.AUTH_URL,
    userStore: new WebStorageStateStore({ store: localStorage}),
    silent_redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}/silent.html`,
    accessTokenExpiringNotificationTime: 120,
    silentRequestTimeout: 80000000,
    automaticSilentRenew: true,
    loadUserInfo: true,
};

const userManager = createUserManager(userManagerConfig);

export default userManager;
